export default "__VITE_ASSET__a59a187f__"